import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translate, detectLang, SUPPORTED_LANGS, LANG_LABELS } from '../i18n';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectLang);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    if (!SUPPORTED_LANGS.includes(l)) return;
    localStorage.setItem('site_lang', l);
    setLangState(l);
  }, []);

  const t = useCallback((key) => translate(lang, key), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
export { SUPPORTED_LANGS, LANG_LABELS };
